<div class="card-body p-0 chapter-event-nfr">
    <div class="row">
        <div class="col-12">
            <!-- Header with Add Event Button -->
            <div class="rana-page-header">
                <div>
                    <h1 class="rana-page-title">Chapter Events</h1>
                    <p class="rana-page-subtitle mb-0">{{ events.length }} event{{ events.length === 1 ? '' : 's' }} on the calendar</p>
                </div>
                <button type="button" class="btn btn-dark-primary"
                        data-toggle="modal" data-target="#modal-add-event"
                        *ngIf="allChapters || (userRole?.EVENT?.includes('CREATE') && userChapter === chapterId)">
                    <i class="uil uil-plus-circle mr-1"></i> Add Event
                </button>
            </div>

            <div class="rana-divider-accent"></div>

            <!-- Events List -->
            <div class="col-12">
                <div class="rana-empty-state" *ngIf="!events || events.length === 0">
                    <i class="uil uil-calendar-alt"></i>
                    <p class="mb-0">No events yet.</p>
                </div>

                <div class="rana-event-list" *ngIf="events && events.length > 0">
                    <div class="rana-event-row"
                         *ngFor="let event of events | paginate: {  id: 'chapterEvents', itemsPerPage: 5, currentPage: page }"
                         (click)="viewEvent(event)">
                        <div class="rana-event-date">
                            <div class="rana-event-date-month">{{ event.eventStartDate | date:'MMM' }}</div>
                            <div class="rana-event-date-day">{{ event.eventStartDate | date:'d' }}</div>
                        </div>
                        <div class="rana-event-main min-width-0">
                            <div class="rana-event-title text-truncate">{{ event.title }}</div>
                            <div class="rana-event-meta">
                                <i class="uil uil-map-marker"></i>
                                <span class="text-truncate">{{ event.eventLocation || 'Location TBD' }}</span>
                                <span class="rana-event-dot">&middot;</span>
                                <i class="uil uil-clock"></i>
                                <span>{{ event.eventStartDate | date:'shortTime' }}</span>
                            </div>
                        </div>
                        <div class="rana-event-tags">
                            <span class="rana-badge" [ngClass]="event.eventType === 'paid' ? 'rana-badge-accent' : 'rana-badge-success'">
                                {{ event.eventType === 'paid' ? 'Paid' : 'Free' }}
                            </span>
                            <span class="rana-badge rana-badge-neutral">{{ event.eventScope || 'CHAPTER' }}</span>
                        </div>
                        <i class="uil uil-angle-right-b rana-event-arrow"></i>
                    </div>
                </div>

                <!-- Pagination -->
                <pagination-controls  id="chapterEvents" *ngIf="events && events.length > 5"
                                     (pageChange)="page = $event"></pagination-controls>
            </div>
        </div>
    </div>
</div>

<!-- -------------------- View Event Modal -------------------- -->
<div class="modal fade" id="modal-view-event" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content section-background-13">

            <!-- Header -->
            <div class="modal-header background-mom-header p-3 flex-column align-items-start">
                <div class="d-flex w-100">
                    <h6 class="text-white mb-0 flex-grow-1">{{ selectedEvent?.title }}</h6>
                    <button type="button" class="close text-white ml-2" data-dismiss="modal">
                        <i class="uil uil-multiply"></i>
                    </button>
                </div>
                <div class="text-white small mt-2 w-100 d-flex justify-content-between flex-wrap">
          <span>
            Created by: {{ selectedEvent?.createdByName }}
              <i class="uil uil-calendar-alt size-20 px-2"></i>
              {{ selectedEvent?.createdDate }}
          </span>
                    <span>
            Status: <i class="uil uil-check-circle"></i> {{ selectedEvent?.status }}
          </span>
                </div>
            </div>

            <!-- Body -->
            <div class="modal-body z-bigger">
                <div class="container-fluid">
                    <div class="row">
                        <!-- Event Details Left Column -->
                        <div class="col-md-6">
                            <p><strong>Location:</strong> {{ selectedEvent?.eventLocation }}</p>
                            <p><strong>Type:</strong> {{ selectedEvent?.eventType }}</p>
                            <p><strong>Scope:</strong> {{ selectedEvent?.eventScope || 'CHAPTER' }}</p>
                            <p>
                                <strong>Start:</strong> {{ selectedEvent?.eventStartDate | date:'mediumDate' }} {{ selectedEvent?.eventStartTime }}
                            </p>
                            <p>
                                <strong>End:</strong> {{ selectedEvent?.eventEndDate | date:'mediumDate' }} {{ selectedEvent?.eventEndTime }}
                            </p>
                            <p *ngIf="selectedEvent?.eventType === 'paid'"><strong>Fee
                                (Adult):</strong> {{ selectedEvent?.eventFeeAdult | currency }}</p>
                            <p *ngIf="selectedEvent?.eventType === 'paid'"><strong>Fee
                                (Child):</strong> {{ selectedEvent?.eventFeeChild | currency }}</p>
                            <p *ngIf="selectedEvent?.eventType === 'paid'"><strong>Fee
                                (Senior):</strong> {{ selectedEvent?.eventFeeSeniorCitizen | currency }}</p>
                            <p *ngIf="selectedEvent?.eventType === 'paid' && selectedEvent?.childAgeLimit">
                                <strong>Child Age Rule:</strong> Children ages {{ selectedEvent?.childAgeMin || 5 }} to {{ selectedEvent?.childAgeLimit }} are counted as Children. Above {{ selectedEvent?.childAgeLimit }} are counted as Adults.
                            </p>
                        </div>

                        <!-- Event Description Right Column -->
                        <div class="col-md-6">
                            <label><strong>Description:</strong></label>
                            <app-rt-editor *ngIf="selectedEvent" [disabled]="true"
                                           [ngModel]="selectedEvent.eventDescription"></app-rt-editor>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="row mt-4">
                        <div class="col-12 text-center">
                            <button class="btn btn-sm btn-warning mr-2"
                                    *ngIf="allChapters || (userRole?.EVENT?.includes('UPDATE') && userChapter === chapterId)"
                                    data-toggle="modal"
                                    data-target="#modal-edit-event"
                                    (click)="openEditEvent(selectedEvent)">
                                <i class="uil uil-edit"></i> Edit
                            </button>
                            <button class="btn btn-sm btn-danger"
                                    *ngIf="allChapters || (userRole?.EVENT?.includes('DELETE') && userChapter === chapterId)"
                                    (click)="deleteEvent(selectedEvent?.id)">
                                <i class="uil uil-trash"></i> Delete
                            </button>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>

<!-- -------------------- Add Event Modal -------------------- -->
<!-- (keep your add modal as you had it) -->

<!-- -------------------- Edit Event Modal -------------------- -->
<!-- (keep your edit modal as you had it) -->

<!-- -------------------- Add Email Modal -------------------- -->
<!-- (keep your add email modal as you had it) -->


<!-- -------------------- Add Event Modal -------------------- -->
<div class="modal fade" id="modal-add-event" tabindex="-1" #addEventModal>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <button type="button" class="close" data-dismiss="modal">
                    <i class="uil uil-multiply"></i>
                </button>
                <div class="row justify-content-center">
                    <div class="col-12 text-center mb-3"><h5>Add Event</h5></div>
                    <div class="col-12">
                        <form (ngSubmit)="addEvent()" class="container-fluid nfr-form-standard">
                            <div class="row mt-3">
                                <!-- Event Title -->
                                <div class="col-md-6 form-group">
                                    <label>Event Title</label>
                                    <input type="text" [(ngModel)]="newEvent.title" name="title"
                                           class="form-style big w-100" placeholder="Event Title" required>
                                </div>

                                <!-- Location -->
                                <div class="col-md-6 form-group">
                                    <label>Location</label>
                                    <input type="text" [(ngModel)]="newEvent.eventLocation" name="location"
                                           class="form-style big w-100" placeholder="Location" required>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <!-- Start Date & Time -->
                                <div class="col-md-3 form-group">
                                    <label>Start Date</label>
                                    <input type="date" [(ngModel)]="newEvent.eventStartDate" name="startDate"
                                           class="form-control">
                                </div>
                                <div class="col-md-3 form-group">
                                    <label>Start Time</label>
                                    <input type="time" [(ngModel)]="newEvent.eventStartTime" name="startTime"
                                           class="form-control">
                                </div>

                                <!-- End Date & Time -->
                                <div class="col-md-3 form-group">
                                    <label>End Date</label>
                                    <input type="date" [(ngModel)]="newEvent.eventEndDate" name="endDate"
                                           class="form-control">
                                </div>
                                <div class="col-md-3 form-group">
                                    <label>End Time</label>
                                    <input type="time" [(ngModel)]="newEvent.eventEndTime" name="endTime"
                                           class="form-control">
                                </div>
                            </div>

                            <div class="row mt-3">
                                <!-- Event Type & Status -->
                                <div class="col-md-4 form-group mx-2">
                                    <label>Event Type</label>
                                    <select [(ngModel)]="newEvent.eventType" name="type" class="form-control">
                                        <option value="free">Free</option>
                                        <option value="paid">Paid</option>
                                    </select>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Status</label>
                                    <select [(ngModel)]="newEvent.status" name="status" class="form-control">
                                        <option value="OPEN">Open</option>
                                        <option value="CLOSED">Closed</option>
                                        <option value="DRAFT">Draft</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row mt-2" *ngIf="newEvent.eventScope === 'NEC'">
                                <div class="col-12 mx-2">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="notifyLandingPage"
                                               name="notifyLandingPage" [(ngModel)]="newEvent.notifyLandingPage">
                                        <label class="form-check-label" for="notifyLandingPage">
                                            Show on public landing page while Open
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col-md-4 form-group mx-2">
                                    <label>Event Category</label>
                                    <select [(ngModel)]="newEvent.eventCategory" (ngModelChange)="onNewEventCategoryChange()" name="eventCategory" class="form-control">
                                        <option value="LOCAL">Local</option>
                                        <option value="CONFERENCE">Conference</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Ticket Options (CONFERENCE only) -->
                            <div class="row mt-3" *ngIf="newEvent.eventCategory === 'CONFERENCE'">
                                <div class="col-12">
                                    <label><strong>Registration Options</strong></label>
                                    <div cdkDropList (cdkDropListDropped)="dropPanel($event, newEventPanels)">
                                    <div *ngFor="let panel of newEventPanels; let pi = index; trackBy: trackByIndex" cdkDrag class="border rounded p-2 mb-3">
                                        <div class="d-flex align-items-center mb-2">
                                            <span class="drag-handle mr-2" cdkDragHandle title="Drag to reorder">&#8942;&#8942;</span>
                                            <input class="form-control form-control-sm font-weight-bold"
                                                   [(ngModel)]="panel.label"
                                                   [name]="'newPanelLabel' + pi"
                                                   placeholder="Section heading (e.g. Registration Fees)">
                                            <button type="button" class="btn btn-sm btn-outline-danger ml-2"
                                                    (click)="removePanel(newEventPanels, pi)">
                                                <i class="uil uil-times"></i>
                                            </button>
                                        </div>
                                        <div class="form-check mb-2">
                                            <input type="checkbox" class="form-check-input"
                                                   [id]="'newPanGroupRequired' + pi"
                                                   [name]="'newPanGroupRequired' + pi"
                                                   [(ngModel)]="panel.groupRequired">
                                            <label class="form-check-label" [for]="'newPanGroupRequired' + pi">
                                                Require at least one selection in this section
                                            </label>
                                        </div>
                                        <div *ngFor="let opt of panel.options; let oi = index" class="row mb-1 align-items-center">
                                            <div class="col-md-4 pr-1">
                                                <input class="form-control form-control-sm mb-1" [(ngModel)]="opt.label"
                                                       [name]="'newPanOpt' + pi + '_' + oi" placeholder="Label">
                                                <input class="form-control form-control-sm" [(ngModel)]="opt.subText"
                                                       [name]="'newPanOptSub' + pi + '_' + oi" placeholder="Sub text (optional)">
                                            </div>
                                            <div class="col-md-3 px-1">
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input"
                                                           [id]="'newPanPaid' + pi + '_' + oi"
                                                           [name]="'newPanPaid' + pi + '_' + oi"
                                                           [(ngModel)]="opt.paid">
                                                    <label class="form-check-label" [for]="'newPanPaid' + pi + '_' + oi">Paid</label>
                                                </div>
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input"
                                                           [id]="'newPanRequired' + pi + '_' + oi"
                                                           [name]="'newPanRequired' + pi + '_' + oi"
                                                           [(ngModel)]="opt.required">
                                                    <label class="form-check-label" [for]="'newPanRequired' + pi + '_' + oi">Required</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3 px-1">
                                                <input *ngIf="opt.paid" class="form-control form-control-sm" [(ngModel)]="opt.price"
                                                       [name]="'newPanPrice' + pi + '_' + oi" placeholder="Price" type="number" min="0">
                                                <small *ngIf="!opt.paid" class="text-muted">Informational only</small>
                                            </div>
                                            <div class="col-md-2 pl-1">
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeOptionFromPanel(panel, oi)">
                                                    <i class="uil uil-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-sm btn-outline-secondary mt-1"
                                                (click)="addOptionToPanel(panel)">
                                            <i class="uil uil-plus"></i> Add Option
                                        </button>
                                    </div>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-secondary mt-1"
                                            (click)="addPanel(newEventPanels)">
                                        <i class="uil uil-plus"></i> Add Section
                                    </button>
                                </div>
                            </div>

                            <!-- Registration questions (LOCAL and CONFERENCE) -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label><strong>Registration Questions</strong></label>
                                    <small class="d-block text-muted mb-2">Ask attendees your own questions when they register: one answer (radio) or several (checkboxes).</small>
                                    <app-question-editor [questions]="newEventQuestions" idPrefix="newRq"></app-question-editor>
                                </div>
                            </div>

                            <!-- Fees (only for paid LOCAL events) -->
                            <div class="row mt-3" *ngIf="newEvent.eventType === 'paid' && newEvent.eventCategory !== 'CONFERENCE'">
                                <div class="col-md-4 form-group">
                                    <label>Fee (Adult)</label>
                                    <input type="number" [(ngModel)]="newEvent.eventFeeAdult" name="feeAdult"
                                           class="form-style big w-100" placeholder="0.00">
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Fee (Child)</label>
                                    <input type="number" [(ngModel)]="newEvent.eventFeeChild" name="feeChild"
                                           class="form-style big w-100" placeholder="0.00">
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Fee (Senior Citizen)</label>
                                    <input type="number" [(ngModel)]="newEvent.eventFeeSeniorCitizen" name="feeSenior"
                                           class="form-style big w-100" placeholder="0.00">
                                </div>
                            </div>
                            <div class="row mt-3" *ngIf="newEvent.eventType === 'paid' && newEvent.eventCategory !== 'CONFERENCE'">
                                <div class="col-md-6 form-group">
                                    <label>Child Minimum Age</label>
                                    <input type="number" [(ngModel)]="newEvent.childAgeMin" name="childAgeMin"
                                           class="form-style big w-100" min="0"
                                           placeholder="Default 5">
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Child Maximum Age</label>
                                    <input type="number" [(ngModel)]="newEvent.childAgeLimit" name="childAgeLimit"
                                           class="form-style big w-100" [min]="newEvent.childAgeMin || 0"
                                           placeholder="e.g. 12">
                                </div>
                                <div class="col-12 mt-1">
                                    <small class="text-muted">Ages between min and max are counted as Children; above max count as Adults.</small>
                                </div>
                            </div>

                            <!-- Early bird / date-window discount (applies to fees only, for both LOCAL and CONFERENCE paid events) -->
                            <div class="row mt-3" *ngIf="newEvent.eventType === 'paid'">
                                <div class="col-12">
                                    <label>Early Bird Discount (optional)</label>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Discount Name</label>
                                    <input type="text" [(ngModel)]="newEvent.discountLabel" name="discountLabel"
                                           class="form-style big w-100" placeholder="e.g. Early Bird Discount" maxlength="60">
                                    <small class="text-muted">Shown exactly as typed wherever the discount appears on the event page. Defaults to "Early Bird Discount" if left blank.</small>
                                </div>
                                <div class="col-md-3 form-group">
                                    <label>Discount Type</label>
                                    <select [(ngModel)]="newEvent.discountType" name="discountType" class="form-style big w-100">
                                        <option value="FLAT">Flat $ amount</option>
                                        <option value="PERCENT">Percent %</option>
                                    </select>
                                </div>
                                <div class="col-md-3 form-group">
                                    <label>Discount Value</label>
                                    <input type="number" [(ngModel)]="newEvent.discountValue" name="discountValue"
                                           class="form-style big w-100" min="0" placeholder="e.g. 20">
                                </div>
                                <div class="col-md-3 form-group">
                                    <label>Discount Start Date</label>
                                    <input type="date" [(ngModel)]="newEvent.discountStartDate" name="discountStartDate"
                                           class="form-style big w-100">
                                </div>
                                <div class="col-md-3 form-group">
                                    <label>Discount End Date</label>
                                    <input type="date" [(ngModel)]="newEvent.discountEndDate" name="discountEndDate"
                                           class="form-style big w-100">
                                </div>
                                <div class="col-12 mt-1">
                                    <small class="text-muted">Applies to registration fees only (not donations). Leave value blank to disable. Automatically reverts to the normal total once the end date passes.</small>
                                </div>
                            </div>

                            <!-- Payment options: card toggle + offline details shown next to Zelle/Check -->
                            <div class="row mt-3" *ngIf="newEvent.eventType === 'paid'">
                                <div class="col-12 form-group mb-0">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="stripePaymentEnabled"
                                               name="stripePaymentEnabled" [(ngModel)]="newEvent.stripePaymentEnabled">
                                        <label class="form-check-label" for="stripePaymentEnabled">
                                            Accept credit card payments (Stripe)
                                        </label>
                                    </div>
                                    <small class="text-muted">When unchecked, "Pay with Card" is hidden from registrants.</small>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Zelle Payment Info</label>
                                    <input type="text" [(ngModel)]="newEvent.zellePaymentDetails" name="zellePaymentDetails"
                                           class="form-style big w-100" placeholder="Email or phone number for Zelle">
                                    <small class="text-muted">Shown to registrants when they choose "Pay with Zelle".</small>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Check Payment Info</label>
                                    <textarea rows="2" [(ngModel)]="newEvent.checkPaymentDetails" name="checkPaymentDetails"
                                           class="form-style big w-100" placeholder="Payable to: Chapter Name&#10;Mailing address, City, ST ZIP"></textarea>
                                    <small class="text-muted">Shown to registrants when they choose "Pay by Check". Put the mailing address on its own line.</small>
                                </div>
                            </div>

                            <!-- CC Email Ids -->
                            <div class="row mt-3">
                                <div class="col-12 form-group">
                                    <label>CC Email Ids</label>
                                    <input type="text" [(ngModel)]="newEventCcEmailsInput" name="ccEmailIds"
                                           class="form-control" placeholder="Enter comma-separated emails (e.g. user1@email.com, user2@email.com)">
                                    <small class="text-muted">These addresses will be CC'd on registration and payment confirmation emails for this event.</small>
                                </div>
                            </div>

                            <!-- Guest of Honors (optional — shown on the event page only when at least one guest is entered) -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label><strong>Guest of Honors</strong></label>
                                    <small class="text-muted d-block mb-2">Optional. If left empty, no Guest of Honors section is shown on the event page.</small>
                                    <div *ngFor="let member of newEvent.eventGuestsOfHonor; let mi = index" class="border rounded p-2 mb-2">
                                        <div class="row">
                                            <div class="col-md-4 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.name"
                                                       [name]="'newGuestName' + mi" placeholder="Name">
                                            </div>
                                            <div class="col-md-4 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.title"
                                                       [name]="'newGuestTitle' + mi" placeholder="Title / role (e.g. Guest of Honor)">
                                            </div>
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.photoUrl"
                                                       [name]="'newGuestPhoto' + mi" placeholder="Photo URL (optional)">
                                            </div>
                                            <div class="col-md-1 mb-1 text-right">
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeCommitteeMember(newEvent.eventGuestsOfHonor!, mi)">
                                                    <i class="uil uil-times"></i>
                                                </button>
                                            </div>
                                            <div class="col-12">
                                                <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="member.shortDescription"
                                                          [name]="'newGuestDesc' + mi" placeholder="Short description"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-outline-secondary mt-1"
                                            (click)="addCommitteeMember(newEvent.eventGuestsOfHonor!)">
                                        <i class="uil uil-plus"></i> Add Guest of Honor
                                    </button>
                                </div>
                            </div>

                            <!-- Featured Speakers (optional — shown on the event page only when at least one speaker is entered) -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label><strong>Featured Speakers</strong></label>
                                    <small class="text-muted d-block mb-2">Optional. If left empty, no speakers section is shown on the event page.</small>
                                    <div *ngFor="let speaker of newEvent.eventSpeakers; let si = index" class="border rounded p-2 mb-2">
                                        <div class="row">
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.name"
                                                       [name]="'newSpeakerName' + si" placeholder="Name">
                                            </div>
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.role"
                                                       [name]="'newSpeakerRole' + si" placeholder="Role (e.g. Keynote Speaker)">
                                            </div>
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.company"
                                                       [name]="'newSpeakerCompany' + si" placeholder="Company (optional)">
                                            </div>
                                            <div class="col-md-2 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.photoUrl"
                                                       [name]="'newSpeakerPhoto' + si" placeholder="Photo URL (optional)">
                                            </div>
                                            <div class="col-md-1 mb-1 text-right">
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeSpeaker(newEvent.eventSpeakers!, si)">
                                                    <i class="uil uil-times"></i>
                                                </button>
                                            </div>
                                            <div class="col-12 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.topic"
                                                       [name]="'newSpeakerTopic' + si" placeholder="Topic (optional)">
                                            </div>
                                            <div class="col-12">
                                                <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="speaker.topicDescription"
                                                          [name]="'newSpeakerTopicDesc' + si" placeholder="Short description of the topic (optional)"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-outline-secondary mt-1"
                                            (click)="addSpeaker(newEvent.eventSpeakers!)">
                                        <i class="uil uil-plus"></i> Add Speaker
                                    </button>
                                </div>
                            </div>

                            <!-- Event Committee (optional — shown on the event page only when at least one member is entered) -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label><strong>Event Committee</strong></label>
                                    <small class="text-muted d-block mb-2">Optional. If left empty, no committee section is shown on the event page. Linking a member account grants that person full management access to this event.</small>
                                    <div *ngFor="let member of newEvent.eventCommittee; let mi = index" class="border rounded p-2 mb-2">
                                        <div class="row">
                                            <div class="col-md-4 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.name"
                                                       [name]="'newCommitteeName' + mi" placeholder="Name">
                                            </div>
                                            <div class="col-md-4 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.title"
                                                       [name]="'newCommitteeTitle' + mi" placeholder="Title / role (e.g. Program Chair)">
                                            </div>
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.photoUrl"
                                                       [name]="'newCommitteePhoto' + mi" placeholder="Photo URL (optional)">
                                            </div>
                                            <div class="col-md-1 mb-1 text-right">
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeCommitteeMember(newEvent.eventCommittee!, mi)">
                                                    <i class="uil uil-times"></i>
                                                </button>
                                            </div>
                                            <div class="col-12 mb-1">
                                                <app-member-search-select
                                                    [members]="chapterMembers"
                                                    [value]="member.memberId"
                                                    (valueChange)="member.memberId = $event">
                                                </app-member-search-select>
                                            </div>
                                            <div class="col-12">
                                                <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="member.shortDescription"
                                                          [name]="'newCommitteeDesc' + mi" placeholder="Short description"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-outline-secondary mt-1"
                                            (click)="addCommitteeMember(newEvent.eventCommittee!)">
                                        <i class="uil uil-plus"></i> Add Committee Member
                                    </button>
                                </div>
                            </div>

                            <!-- Description -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label>Description</label>
                                    <app-rt-editor [(ngModel)]="newEvent.eventDescription" name="description"></app-rt-editor>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-12 text-center">
                                    <button type="submit" class="btn btn-primary">Submit <i
                                            class="uil uil-check-circle ml-2"></i></button>
                                </div>
                            </div>
                        </form>


                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- -------------------- Edit Event Modal -------------------- -->
<div class="modal fade" id="modal-edit-event" tabindex="-1" #editEventModal>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <button type="button" class="close" data-dismiss="modal">
                    <i class="uil uil-multiply"></i>
                </button>
                <div class="row justify-content-center">
                    <div class="col-12 text-center mb-3"><h5>Edit Event</h5></div>
                    <div class="col-12" *ngIf="selectedEvent">
                        <form (ngSubmit)="updateEvent()" class="container-fluid nfr-form-standard">
                            <div class="row">
                                <!-- Event Title -->
                                <div class="col-md-6 form-group mt-2">
                                    <input type="text" [(ngModel)]="selectedEvent.title" name="editTitle"
                                           class="form-style big w-100" placeholder="Event Title" required>
                                </div>

                                <!-- Location -->
                                <div class="col-md-6 form-group mt-2">
                                    <input type="text" [(ngModel)]="selectedEvent.eventLocation" name="editLocation"
                                           class="form-style big w-100" placeholder="Location" required>
                                </div>
                            </div>

                            <div class="row">
                                <!-- Start Date & Time -->
                                <div class="col-md-3 form-group mt-2">
                                    <label>Start Date</label>
                                    <input type="date" [(ngModel)]="selectedEvent.eventStartDate" name="editStartDate"
                                           class="form-control">
                                </div>
                                <div class="col-md-3 form-group mt-2">
                                    <label>Start Time</label>
                                    <input type="time" [(ngModel)]="selectedEvent.eventStartTime" name="editStartTime"
                                           class="form-control">
                                </div>

                                <!-- End Date & Time -->
                                <div class="col-md-3 form-group mt-2">
                                    <label>End Date</label>
                                    <input type="date" [(ngModel)]="selectedEvent.eventEndDate" name="editEndDate"
                                           class="form-control">
                                </div>
                                <div class="col-md-3 form-group mt-2">
                                    <label>End Time</label>
                                    <input type="time" [(ngModel)]="selectedEvent.eventEndTime" name="editEndTime"
                                           class="form-control">
                                </div>
                            </div>

                            <div class="row">
                                <!-- Event Type & Status -->
                                <div class="col-md-4 form-group mt-2">
                                    <label>Event Type</label>
                                    <select [(ngModel)]="selectedEvent.eventType" name="editType" class="form-control">
                                        <option value="free">Free</option>
                                        <option value="paid">Paid</option>
                                    </select>
                                </div>
                                <div class="col-md-4 form-group mt-2">
                                    <label>Scope</label>
                                    <select [(ngModel)]="selectedEvent.eventScope" name="editEventScope" class="form-control" [disabled]="!isNecExecutive">
                                        <option value="CHAPTER">CHAPTER</option>
                                        <option value="NEC">NEC</option>
                                    </select>
                                </div>
                                <div class="col-md-4 form-group mt-2">
                                    <label>Status</label>
                                    <select [(ngModel)]="selectedEvent.status" name="editStatus" class="form-control">
                                        <option value="OPEN">Open</option>
                                        <option value="CLOSED">Closed</option>
                                        <option value="DRAFT">Draft</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row" *ngIf="selectedEvent.eventScope === 'NEC'">
                                <div class="col-md-6 mt-2">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="editNotifyLandingPage"
                                               name="editNotifyLandingPage" [(ngModel)]="selectedEvent.notifyLandingPage">
                                        <label class="form-check-label" for="editNotifyLandingPage">
                                            Show on public landing page while Open
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col-md-4 form-group">
                                    <label>Event Category</label>
                                    <select [(ngModel)]="selectedEvent.eventCategory" name="editEventCategory" class="form-control">
                                        <option value="LOCAL">Local</option>
                                        <option value="CONFERENCE">Conference</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Ticket Options (CONFERENCE only) -->
                            <div class="row mt-2" *ngIf="selectedEvent.eventCategory === 'CONFERENCE'">
                                <div class="col-12">
                                    <label><strong>Registration Options</strong></label>
                                    <div cdkDropList (cdkDropListDropped)="dropPanel($event, selectedEventPanels)">
                                    <div *ngFor="let panel of selectedEventPanels; let pi = index; trackBy: trackByIndex" cdkDrag class="border rounded p-2 mb-3">
                                        <div class="d-flex align-items-center mb-2">
                                            <span class="drag-handle mr-2" cdkDragHandle title="Drag to reorder">&#8942;&#8942;</span>
                                            <input class="form-control form-control-sm font-weight-bold"
                                                   [(ngModel)]="panel.label"
                                                   [name]="'editPanelLabel' + pi"
                                                   placeholder="Section heading (e.g. Registration Fees)">
                                            <button type="button" class="btn btn-sm btn-outline-danger ml-2"
                                                    (click)="removePanel(selectedEventPanels, pi)">
                                                <i class="uil uil-times"></i>
                                            </button>
                                        </div>
                                        <div class="form-check mb-2">
                                            <input type="checkbox" class="form-check-input"
                                                   [id]="'editPanGroupRequired' + pi"
                                                   [name]="'editPanGroupRequired' + pi"
                                                   [(ngModel)]="panel.groupRequired">
                                            <label class="form-check-label" [for]="'editPanGroupRequired' + pi">
                                                Require at least one selection in this section
                                            </label>
                                        </div>
                                        <div *ngFor="let opt of panel.options; let oi = index" class="row mb-1 align-items-center">
                                            <div class="col-md-4 pr-1">
                                                <input class="form-control form-control-sm mb-1" [(ngModel)]="opt.label"
                                                       [name]="'editPanOpt' + pi + '_' + oi" placeholder="Label">
                                                <input class="form-control form-control-sm" [(ngModel)]="opt.subText"
                                                       [name]="'editPanOptSub' + pi + '_' + oi" placeholder="Sub text (optional)">
                                            </div>
                                            <div class="col-md-3 px-1">
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input"
                                                           [id]="'editPanPaid' + pi + '_' + oi"
                                                           [name]="'editPanPaid' + pi + '_' + oi"
                                                           [(ngModel)]="opt.paid">
                                                    <label class="form-check-label" [for]="'editPanPaid' + pi + '_' + oi">Paid</label>
                                                </div>
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input"
                                                           [id]="'editPanRequired' + pi + '_' + oi"
                                                           [name]="'editPanRequired' + pi + '_' + oi"
                                                           [(ngModel)]="opt.required">
                                                    <label class="form-check-label" [for]="'editPanRequired' + pi + '_' + oi">Required</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3 px-1">
                                                <input *ngIf="opt.paid" class="form-control form-control-sm" [(ngModel)]="opt.price"
                                                       [name]="'editPanPrice' + pi + '_' + oi" placeholder="Price" type="number" min="0">
                                                <small *ngIf="!opt.paid" class="text-muted">Informational only</small>
                                            </div>
                                            <div class="col-md-2 pl-1">
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeOptionFromPanel(panel, oi)">
                                                    <i class="uil uil-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-sm btn-outline-secondary mt-1"
                                                (click)="addOptionToPanel(panel)">
                                            <i class="uil uil-plus"></i> Add Option
                                        </button>
                                    </div>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-secondary mt-1"
                                            (click)="addPanel(selectedEventPanels)">
                                        <i class="uil uil-plus"></i> Add Section
                                    </button>
                                </div>
                            </div>

                            <!-- Registration questions (LOCAL and CONFERENCE) -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label><strong>Registration Questions</strong></label>
                                    <small class="d-block text-muted mb-2">Ask attendees your own questions when they register: one answer (radio) or several (checkboxes).</small>
                                    <small *ngIf="selectedQuestionsLegacy && !selectedQuestionsDirty" class="d-block text-info mb-2">
                                        This event still uses the built-in "Are you attending?" question. Changing the questions here replaces it.
                                    </small>
                                    <app-question-editor [questions]="selectedEventQuestions" idPrefix="editRq"
                                                         (questionsChange)="onSelectedQuestionsChange()"></app-question-editor>
                                </div>
                            </div>

                            <!-- Fees (only for paid LOCAL events) -->
                            <div class="row" *ngIf="selectedEvent.eventType === 'paid' && selectedEvent.eventCategory !== 'CONFERENCE'">
                                <div class="col-md-4 form-group mt-2">
                                    <input type="number" [(ngModel)]="selectedEvent.eventFeeAdult" name="editFeeAdult"
                                           class="form-style big w-100" placeholder="Fee (Adult)">
                                </div>
                                <div class="col-md-4 form-group mt-2">
                                    <input type="number" [(ngModel)]="selectedEvent.eventFeeChild" name="editFeeChild"
                                           class="form-style big w-100" placeholder="Fee (Child)">
                                </div>
                                <div class="col-md-4 form-group mt-2">
                                    <input type="number" [(ngModel)]="selectedEvent.eventFeeSeniorCitizen"
                                           name="editFeeSenior" class="form-style big w-100"
                                           placeholder="Fee (Senior Citizen)">
                                </div>
                            </div>
                            <div class="row" *ngIf="selectedEvent.eventType === 'paid' && selectedEvent.eventCategory !== 'CONFERENCE'">
                                <div class="col-md-6 form-group mt-2">
                                    <input type="number" [(ngModel)]="selectedEvent.childAgeMin"
                                           name="editChildAgeMin" class="form-style big w-100"
                                           min="0"
                                           placeholder="Child minimum age (default 5)">
                                </div>
                                <div class="col-md-6 form-group mt-2">
                                    <input type="number" [(ngModel)]="selectedEvent.childAgeLimit"
                                           name="editChildAgeLimit" class="form-style big w-100"
                                           min="0"
                                           placeholder="Child maximum age">
                                    <small class="text-muted">Children between min and max are counted as Children; above max count as Adults.</small>
                                </div>
                            </div>

                            <!-- Early bird / date-window discount (applies to fees only, for both LOCAL and CONFERENCE paid events) -->
                            <div class="row" *ngIf="selectedEvent.eventType === 'paid'">
                                <div class="col-12">
                                    <label>Early Bird Discount (optional)</label>
                                </div>
                                <div class="col-md-6 form-group mt-2">
                                    <label>Discount Name</label>
                                    <input type="text" [(ngModel)]="selectedEvent.discountLabel" name="editDiscountLabel"
                                           class="form-style big w-100" placeholder="e.g. Early Bird Discount" maxlength="60">
                                    <small class="text-muted">Shown exactly as typed wherever the discount appears on the event page. Defaults to "Early Bird Discount" if left blank.</small>
                                </div>
                                <div class="col-md-3 form-group mt-2">
                                    <label>Discount Type</label>
                                    <select [(ngModel)]="selectedEvent.discountType" name="editDiscountType" class="form-style big w-100">
                                        <option value="FLAT">Flat $ amount</option>
                                        <option value="PERCENT">Percent %</option>
                                    </select>
                                </div>
                                <div class="col-md-3 form-group mt-2">
                                    <label>Discount Value</label>
                                    <input type="number" [(ngModel)]="selectedEvent.discountValue" name="editDiscountValue"
                                           class="form-style big w-100" min="0" placeholder="e.g. 20">
                                </div>
                                <div class="col-md-3 form-group mt-2">
                                    <label>Discount Start Date</label>
                                    <input type="date" [(ngModel)]="selectedEvent.discountStartDate" name="editDiscountStartDate"
                                           class="form-style big w-100">
                                </div>
                                <div class="col-md-3 form-group mt-2">
                                    <label>Discount End Date</label>
                                    <input type="date" [(ngModel)]="selectedEvent.discountEndDate" name="editDiscountEndDate"
                                           class="form-style big w-100">
                                </div>
                                <div class="col-12 mt-1">
                                    <small class="text-muted">Applies to registration fees only (not donations). Leave value blank to disable. Automatically reverts to the normal total once the end date passes.</small>
                                </div>
                            </div>

                            <!-- Payment options: card toggle + offline details shown next to Zelle/Check -->
                            <div class="row" *ngIf="selectedEvent.eventType === 'paid'">
                                <div class="col-12 form-group mb-0">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="editStripePaymentEnabled"
                                               name="editStripePaymentEnabled" [(ngModel)]="selectedEvent.stripePaymentEnabled">
                                        <label class="form-check-label" for="editStripePaymentEnabled">
                                            Accept credit card payments (Stripe)
                                        </label>
                                    </div>
                                    <small class="text-muted">When unchecked, "Pay with Card" is hidden from registrants.</small>
                                </div>
                                <div class="col-md-6 form-group mt-2">
                                    <label>Zelle Payment Info</label>
                                    <input type="text" [(ngModel)]="selectedEvent.zellePaymentDetails" name="editZellePaymentDetails"
                                           class="form-style big w-100" placeholder="Email or phone number for Zelle">
                                    <small class="text-muted">Shown to registrants when they choose "Pay with Zelle".</small>
                                </div>
                                <div class="col-md-6 form-group mt-2">
                                    <label>Check Payment Info</label>
                                    <textarea rows="2" [(ngModel)]="selectedEvent.checkPaymentDetails" name="editCheckPaymentDetails"
                                           class="form-style big w-100" placeholder="Payable to: Chapter Name&#10;Mailing address, City, ST ZIP"></textarea>
                                    <small class="text-muted">Shown to registrants when they choose "Pay by Check". Put the mailing address on its own line.</small>
                                </div>
                            </div>

                            <!-- CC Email Ids -->
                            <div class="row mt-3">
                                <div class="col-12 form-group">
                                    <label>CC Email Ids</label>
                                    <input type="text" [(ngModel)]="editEventCcEmailsInput" name="editCcEmailIds"
                                           class="form-control" placeholder="Enter comma-separated emails (e.g. user1@email.com, user2@email.com)">
                                    <small class="text-muted">These addresses will be CC'd on registration and payment confirmation emails for this event.</small>
                                </div>
                            </div>

                            <!-- Guest of Honors (optional — shown on the event page only when at least one guest is entered) -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label><strong>Guest of Honors</strong></label>
                                    <small class="text-muted d-block mb-2">Optional. If left empty, no Guest of Honors section is shown on the event page.</small>
                                    <div *ngFor="let member of editEventGuestsOfHonor; let mi = index" class="border rounded p-2 mb-2">
                                        <div class="row">
                                            <div class="col-md-4 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.name"
                                                       [name]="'editGuestName' + mi" placeholder="Name">
                                            </div>
                                            <div class="col-md-4 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.title"
                                                       [name]="'editGuestTitle' + mi" placeholder="Title / role (e.g. Guest of Honor)">
                                            </div>
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.photoUrl"
                                                       [name]="'editGuestPhoto' + mi" placeholder="Photo URL (optional)">
                                            </div>
                                            <div class="col-md-1 mb-1 text-right">
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeCommitteeMember(editEventGuestsOfHonor, mi)">
                                                    <i class="uil uil-times"></i>
                                                </button>
                                            </div>
                                            <div class="col-12">
                                                <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="member.shortDescription"
                                                          [name]="'editGuestDesc' + mi" placeholder="Short description"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-outline-secondary mt-1"
                                            (click)="addCommitteeMember(editEventGuestsOfHonor)">
                                        <i class="uil uil-plus"></i> Add Guest of Honor
                                    </button>
                                </div>
                            </div>

                            <!-- Featured Speakers (optional — shown on the event page only when at least one speaker is entered) -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label><strong>Featured Speakers</strong></label>
                                    <small class="text-muted d-block mb-2">Optional. If left empty, no speakers section is shown on the event page.</small>
                                    <div *ngFor="let speaker of editEventSpeakers; let si = index" class="border rounded p-2 mb-2">
                                        <div class="row">
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.name"
                                                       [name]="'editSpeakerName' + si" placeholder="Name">
                                            </div>
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.role"
                                                       [name]="'editSpeakerRole' + si" placeholder="Role (e.g. Keynote Speaker)">
                                            </div>
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.company"
                                                       [name]="'editSpeakerCompany' + si" placeholder="Company (optional)">
                                            </div>
                                            <div class="col-md-2 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.photoUrl"
                                                       [name]="'editSpeakerPhoto' + si" placeholder="Photo URL (optional)">
                                            </div>
                                            <div class="col-md-1 mb-1 text-right">
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeSpeaker(editEventSpeakers, si)">
                                                    <i class="uil uil-times"></i>
                                                </button>
                                            </div>
                                            <div class="col-12 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="speaker.topic"
                                                       [name]="'editSpeakerTopic' + si" placeholder="Topic (optional)">
                                            </div>
                                            <div class="col-12">
                                                <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="speaker.topicDescription"
                                                          [name]="'editSpeakerTopicDesc' + si" placeholder="Short description of the topic (optional)"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-outline-secondary mt-1"
                                            (click)="addSpeaker(editEventSpeakers)">
                                        <i class="uil uil-plus"></i> Add Speaker
                                    </button>
                                </div>
                            </div>

                            <!-- Event Committee (optional — shown on the event page only when at least one member is entered) -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label><strong>Event Committee</strong></label>
                                    <small class="text-muted d-block mb-2">Optional. If left empty, no committee section is shown on the event page.</small>
                                    <small class="text-muted d-block mb-2">Linking a member account grants that person full management access to this event.</small>
                                    <div *ngFor="let member of editEventCommittee; let mi = index" class="border rounded p-2 mb-2">
                                        <div class="row">
                                            <div class="col-md-4 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.name"
                                                       [name]="'editCommitteeName' + mi" placeholder="Name">
                                            </div>
                                            <div class="col-md-4 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.title"
                                                       [name]="'editCommitteeTitle' + mi" placeholder="Title / role (e.g. Program Chair)">
                                            </div>
                                            <div class="col-md-3 mb-1">
                                                <input class="form-control form-control-sm" [(ngModel)]="member.photoUrl"
                                                       [name]="'editCommitteePhoto' + mi" placeholder="Photo URL (optional)">
                                            </div>
                                            <div class="col-md-1 mb-1 text-right">
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeCommitteeMember(editEventCommittee, mi)">
                                                    <i class="uil uil-times"></i>
                                                </button>
                                            </div>
                                            <div class="col-12 mb-1">
                                                <app-member-search-select
                                                    [members]="chapterMembers"
                                                    [value]="member.memberId"
                                                    (valueChange)="member.memberId = $event">
                                                </app-member-search-select>
                                            </div>
                                            <div class="col-12">
                                                <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="member.shortDescription"
                                                          [name]="'editCommitteeDesc' + mi" placeholder="Short description"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-outline-secondary mt-1"
                                            (click)="addCommitteeMember(editEventCommittee)">
                                        <i class="uil uil-plus"></i> Add Committee Member
                                    </button>
                                </div>
                            </div>

                            <!-- Description -->
                            <div class="row mt-3">
                                <div class="col-12">
                                    <label>Description</label>
                                    <app-rt-editor [(ngModel)]="selectedEvent.eventDescription" name="editDescription"></app-rt-editor>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-12 text-center">
                                    <button type="submit" class="btn btn-success">
                                        Save Changes <i class="uil uil-check-circle ml-2"></i>
                                    </button>
                                </div>
                            </div>
                        </form>


                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- -------------------- Add Email Modal -------------------- -->
<div class="modal fade" id="modal-add-email" tabindex="-1" #addEmailModal>
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <button type="button" class="close" data-dismiss="modal">
                    <i class="uil uil-multiply"></i>
                </button>
                <div class="row justify-content-center">
                    <div class="col-12 text-center mb-3"><h5>Add Communication Message</h5></div>
                    <div class="col-12">
                        <form (ngSubmit)="addEmail()" class="nfr-form-standard">
                            <div class="form-group mt-3">
                                <input type="text" [(ngModel)]="newEmail.subject" name="subject" class="form-style big"
                                       placeholder="Subject" required>
                            </div>
                            <div class="form-group mt-3">
                                <label>Body</label>
                                <app-rt-editor [(ngModel)]="newEmail.body" name="body"></app-rt-editor>
                            </div>
                            <div class="col-12 text-center mt-4">
                                <button type="submit" class="btn btn-primary">Add Communication <i
                                        class="uil uil-check-circle ml-2"></i></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- You can add similar modals for Expenses, Registrations, and Photos -->
